export default __webpack_public_path__ + "static/media/inteligencia.33798b4e.png";